<template lang="html">
    <div class="ps-product">
        <div class="ps-product__thumbnail">
            <nuxt-link :to="`/${product.linker}`">
                <img
                    v-if="product.pictures == null"
                    v-lazy-load :data-src="`${product.thumbnail.url}`"
                    :alt="product.name"
                />
                <img
                    v-if="product.pictures != null"
                    v-lazy-load :data-src="`${product.pictures}`"
                    :alt="product.name"
                />
            </nuxt-link>
            <div v-if="isSale === true" class="ps-product__badge">sale</div>
            <ul class="ps-product__actions">
                <!-- <li>
                    <a
                        to="#"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Add to cart"
                        @click.prevent="handleAddToCart"
                    >
                        <i class="icon-bag2"></i>
                    </a>
                </li>

                <li>
                    <a
                        href="#"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Add to wishlist"
                        @click.prevent="handleAddItemToWishlist"
                    >
                        <i class="icon-heart"></i>
                    </a>
                </li> -->
                <!-- <li>
                    <a
                        to="#"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Compare"
                        @click.prevent="handleAddItemToCompare"
                    >
                        <i class="icon-chart-bars"></i>
                    </a>
                </li> -->
            </ul>
        </div>
        <div class="ps-product__container">
            <nuxt-link to="/shop" class="ps-product__vendor">
                {{ product.vendor }}
            </nuxt-link>
            <div class="ps-product__content">
                <nuxt-link
                    v-if="product.title != null"
                    :to="`/${product.linker}`"
                    class="ps-product__title"
                >
                    {{ product.title }}
                </nuxt-link>
                <nuxt-link
                    v-if="product.name != null"
                    :to="`/${product.linker}`"
                    class="ps-product__title"
                >
                    {{ product.name }}
                </nuxt-link>
                <!-- <div class="ps-product__rating">
                    <rating />
                    <span>{{ product.ratingCount }}</span>
                </div> -->
                <p
                    v-if="product.is_sale === true"
                    class="ps-product__price sale"
                >
                    {{ currency }}{{ product.price }}
                    <del class="ml-2">
                        {{ currency }}{{ product.sale_price }}
                    </del>
                </p>
                <p v-else class="ps-product__price">
                    {{ currency }}{{ product.price }}
                </p>
            </div>
            <!-- <div class="ps-product__content hover">
                <nuxt-link :to="`/${product.id}`">
                    <a class="ps-product__title">{{ product.title }}</a>
                </nuxt-link>
                <p
                    v-if="product.is_sale === true"
                    class="ps-product__price sale"
                >
                    ${{ product.price }}
                    <del class="ml-2"> ${{ product.sale_price }}</del>
                </p>
                <p v-else class="ps-product__price">${{ product.price }}</p>
            </div> -->
        </div>
        <v-dialog v-model="quickviewDialog" width="1200">
            <div class="ps-dialog">
                <a
                    class="ps-dialog__close"
                    @click.prevent="quickviewDialog = false"
                >
                    <i class="icon icon-cross"></i>
                </a>
                <product-quickview :product="product" />
            </div>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Rating from '../Rating';
import ProductQuickview from '~/components/elements/detail/ProductQuickview';

export default {
    components: { ProductQuickview, Rating },
    props: {
        product: {
            type: Object,
            require: true,
            default: () => {}
        }
    },

    computed: {
        ...mapState({
            cartItems: state => state.cart.cartItems,
            currency: state => state.app.currency
        }),
        isSale() {
            if (this.product.is_sale) {
                return true;
            }
            return false;
        }
    },

    data: () => ({
        productRating: 5,
        productModal: false,
        productPreload: true,
        isImageLoaded: false,
        quickviewDialog: false
    }),
    methods: {
        handleAddToCart() {
            this.$gtm.push({event:"addToCart", 'ecommerce': {
                    'currencyCode': 'INR',
                    'add': {                                // 'add' actionFieldObject measures.
                        'products': [{                        //  adding a product to a shopping cart.
                            'name': this.product.title,
                            'id': this.product.id,
                            'price': this.product.payPrice+'.00',
                            'brand': '',
                            'category': '',
                            'variant': '',
                            'quantity': 1
                        }]
                    }
                }})
            let item = {
                id: this.product.id,
                quantity: 1,
                price: this.product.price,
                category: this.product.category[1]
            };
            this.$store.dispatch('cart/addProductToCart', item);
           // this.getCartProduct(this.cartItems);
            // this.$notify({
            //     group: 'addCartSuccess',
            //     title: 'Success!',
            //     text: `${this.product.title} has been added to your cart!`
            // });
        },

        handleAddItemToWishlist() {
            let item = {
                id: this.product.id
            };

            this.$store.dispatch('wishlist/addItemToWishlist', item);
            // this.$notify({
            //     group: 'addCartSuccess',
            //     title: 'Add to wishlist!',
            //     text: `${this.product.title} has been added to your wishlist !`
            // });
        },

        handleAddItemToCompare() {
            let item = {
                id: this.product.id
            };
            this.$store.dispatch('compare/addItemToCompare', item);
            // this.$notify({
            //     group: 'addCartSuccess',
            //     title: 'Add to compare!',
            //     text: `${this.product.title} has been added to your compare !`
            // });
        },

        async getCartProduct(products) {
            let listOfIds = [];
            products.forEach(item => {
                listOfIds.push(item.id);
            });
            const response = await this.$store.dispatch(
                'product/getCartProducts',
                listOfIds
            );
            if (response) {
                this.$store.commit('cart/setLoading', false);
            }
        }
    }
};
</script>
